import { PaymentCustomerInformationType } from "../../../common/types";
import { PaymentPageTypes } from "../../../common/types/PaymentTypes";
import GroupTitle from "./GroupTitle";



type Props = {
    selectedCustomerInfo: PaymentCustomerInformationType,
    paymentPage: PaymentPageTypes
}
const CustomerInformationArea = (props: Props) => {

    const { selectedCustomerInfo } = props;

    const customerIsAvailable = selectedCustomerInfo.customerName && selectedCustomerInfo.customerName?.length > 0 ;

    if (customerIsAvailable) {
        return (
            <div className="flex-col justify-start items-start flex mt-6">
                <div className="w-full   min-h-[183px] px-6 py-4 bg-white shadow-custom rounded-lg flex-col justify-start items-start gap-2.5 flex">
                    <GroupTitle title={selectedCustomerInfo?.customerName || ""} lineclass="!border-primary absolute left-[-12px] !h-full" />
                    <div className=" text-black text-[13px] font-normal w-full ">
                        <div className="flex items-center justify-between">
                            <div className="flex flex-col">
                                <label className="text-zinc-500 text-xs font-bold">
                                    VKN / TCKN
                                </label>
                                <label className="text-right text-zinc-800 text-xs font-normal ">
                                    {selectedCustomerInfo?.taxCode}
                                </label>
                            </div>
                            <div className="flex flex-col">
                                <label className="text-zinc-500 text-xs font-bold">
                                    Cari Kod
                                </label>
                                <label className="text-right text-zinc-800 text-xs font-normal ">
                                    {selectedCustomerInfo?.customerCode}
                                </label>
                            </div>
                        </div>
                        <div className="my-4 border border-light-border">
                        </div>

                        <div className="flex items-center justify-between">
                            <label>
                                E-posta:
                            </label>
                            <label>
                                {selectedCustomerInfo?.email}
                            </label>
                        </div>
                        <div className="flex items-center justify-between mt-2">
                            <label>
                                Telefon:
                            </label>
                            <label>
                                {selectedCustomerInfo?.phone}
                            </label>
                        </div>
                        {props.paymentPage !== "unexpiredLink" &&(
                            <>
                             <div className="flex items-center justify-between mt-2">
                            <label>
                                İl:
                            </label>
                            <label>
                                {selectedCustomerInfo?.city}
                            </label>
                        </div>
                        <div className="flex items-center justify-between mt-2">
                            <label>
                                İlçe:
                            </label>
                            <label>
                                {selectedCustomerInfo?.district}
                            </label>
                        </div>
                        <div className="flex items-center justify-between mt-2">
                            <label>
                                Adres:
                            </label>
                            <label className="text-right">
                                {selectedCustomerInfo?.address}
                            </label>
                        </div>
                        </>
                        )}
                       
                    </div>
                </div>

            </div>
        );
    }
    return null;

}
export default CustomerInformationArea;